module.exports = __webpack_public_path__ + "img/4.300598b9.png";